// @core/api/endpoints/tag/list_entity_tags.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEntityTagsResponse,
} from '../../../types/tag';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/tag';

/**
 * List tags for an entity
 * Returns tags assigned to a specific entity, filtered by current actor visibility. Shows tenant tags, team tags for actor's teams, and actor's personal tags.
 */
export async function ListEntityTags(
  entity_type: string,
  entity_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListEntityTagsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/entities/:entity_type/:entity_id/tags`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<ListEntityTagsResponse>(requestPath, { ...requestOptions, params });
}
